import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  HostListener
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import jsPDF from 'jspdf';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit, AfterViewInit, OnDestroy {

  // Universal image path set for default and all items
  defaultImageUrl: string = 'assets/images/liberica-visit-us-hero.jpg';

  // =========================================================
  // CATEGORY
  // =========================================================

  categories: any[] = [
    {
      id: 'coffee',
      name: 'Coffee',
      number: '01',
      eyebrow: 'SPECIALTY BREWS',
      description: 'Artisanal coffee brewed to perfection.'
    },
    {
      id: 'food',
      name: 'Food',
      number: '02',
      eyebrow: 'DELICIOUS MEALS',
      description: 'Authentic local dishes and wholesome mains.'
    },
    {
      id: 'beverages',
      name: 'Beverages',
      number: '03',
      eyebrow: 'REFRESHING DRINKS',
      description: 'Cooling teas, mocktails, and fresh beverages.'
    },
    {
      id: 'desserts',
      name: 'Snacks & Desserts',
      number: '04',
      eyebrow: 'SWEET & SAVOURY',
      description: 'Tasty snacks, pastries, and traditional desserts.'
    }
  ];

  selectedCategory: string = 'coffee';

  // =========================================================
  // SEARCH
  // =========================================================

  searchTerm: string = '';

  // =========================================================
  // SUBSECTIONS
  // =========================================================

  foodSections: string[] = [
    'Nasi Lemak',
    'Kolo Mee',
    'Curry Mee',
    'Asam Laksa',
    'ChiKut Teh',
    'Ala Carte',
    'Daily Special Package'
  ];

  beverageSections: string[] = [
    'Beverages',
    'Mocktail',
    'Flower Tea Sachet'
  ];

  dessertSections: string[] = [
    'Snacks',
    'Breakfast',
    'Pastry',
    'Egg Tart',
    'Add On'
  ];

  // =========================================================
  // MENU DATA
  // =========================================================

   menuItems: any[] = [
    // =======================================================
    // FOOD - NASI LEMAK
    // =======================================================
    {
      id: 'N101',
      code: 'N101',
      category: 'food',
      section: 'Nasi Lemak',
      name: 'Nasi Lemak Sambal Merah 招牌椰浆饭',
      price: 14.9,
      image: 'assets/images/nasi-lemak-sambal.jpg'
    },
    {
      id: 'N102',
      code: 'N102',
      category: 'food',
      section: 'Nasi Lemak',
      name: 'Nasi Lemak Johor 柔佛椰浆饭',
      price: 16.9,
      image: 'assets/images/nasi-lemak-johor.jpg'
    },
    {
      id: 'N103',
      code: 'N103',
      category: 'food',
      section: 'Nasi Lemak',
      name: 'Nasi Lemak Biasa 椰浆饭',
      price: 10.9,
      image: 'assets/images/nasi-lemak-biasa.jpg'
    },

    // =======================================================
    // KOLO MEE
    // =======================================================
    {
      id: 'M101',
      code: 'M101',
      category: 'food',
      section: 'Kolo Mee',
      name: 'Sarawak Kolo Mee (Soup) 砂拉越哥罗面(汤)',
      price: 15.9,
      image: 'assets/images/sarawak-kolo-mee-soup.jpg'
    },
    {
      id: 'M102',
      code: 'M102',
      category: 'food',
      section: 'Kolo Mee',
      name: 'Sarawak Kolo Mee (Dry) 砂拉越哥罗面(干)',
      price: 14.9,
      image: 'assets/images/sarawak-kolo-mee-dry.jpg'
    },
    {
      id: 'M103',
      code: 'M103',
      category: 'food',
      section: 'Kolo Mee',
      name: 'Sarawak Kolo Mee (Curry Soup) 砂拉越哥罗面(咖喱汤)',
      price: 16.9,
      image: 'assets/images/sarawak-kolo-mee-curry-soup.jpg'
    },

    // =======================================================
    // CURRY MEE
    // =======================================================
    {
      id: 'M104',
      code: 'M104',
      category: 'food',
      section: 'Curry Mee',
      name: 'Ipoh Curry Mee 怡保咖喱面',
      price: 16.9,
      image: 'assets/images/ipoh-curry-mee.jpg'
    },

    // =======================================================
    // ASAM LAKSA
    // =======================================================
    {
      id: 'M203',
      code: 'M203',
      category: 'food',
      section: 'Asam Laksa',
      name: 'Penang Asam Laksa 槟城亚叁叻沙',
      price: 15.9,
      image: 'assets/images/penang-asam-laksa.jpg'
    },
    {
      id: 'M204',
      code: 'M204',
      category: 'food',
      section: 'Asam Laksa',
      name: 'Asam Laksa Curry Noodle 亚叁叻沙咖喱面',
      price: 16.9,
      image: 'assets/images/asam-laksa-curry-noodle.jpg'
    },

    // =======================================================
    // CHIKUT TEH
    // =======================================================
    {
      id: 'R101',
      code: 'R101',
      category: 'food',
      section: 'ChiKut Teh',
      name: 'ChiKut Teh Soup with Rice CHI骨茶饭',
      price: 16.9,
      image: 'assets/images/chikut-teh-soup-with-rice.jpg'
    },
    {
      id: 'R102',
      code: 'R102',
      category: 'food',
      section: 'ChiKut Teh',
      name: 'ChiKut Teh Soup with Noodles CHI骨茶面',
      price: 16.9,
      image: 'assets/images/chikut-teh-soup-with-noodles.jpg'
    },

    // =======================================================
    // ALA CARTE
    // =======================================================
    {
      id: 'R205',
      code: 'R205',
      category: 'food',
      section: 'Ala Carte',
      name: 'Kapitan Chicken with Potato with Rice 马铃薯甲必丹鸡饭',
      price: 16.9,
      image: 'assets/images/kapitan-chicken-with-potato-with-rice.jpg'
    },
    {
      id: 'R206',
      code: 'R206',
      category: 'food',
      section: 'Ala Carte',
      name: "Black Vinegar Lion's Mane Mushroom with Rice 醋猴头菇饭",
      price: 16.9,
      image: 'assets/images/black-vinegar-lions-mane-mushroom-with-rice.jpg'
    },
    {
      id: 'R207',
      code: 'R207',
      category: 'food',
      section: 'Ala Carte',
      name: "Sesame Oil Lion's Mane Mushroom with Rice 麻油猴头菇饭",
      price: 16.9,
      image: 'assets/images/sesame-oil-lions-mane-mushroom-with-rice.jpg'
    },
    {
      id: 'R208',
      code: 'R208',
      category: 'food',
      section: 'Ala Carte',
      name: 'Curry Rendang Mutton with Rice 仁当咖喱羊肉饭',
      price: 15.9,
      image: 'assets/images/curry-rendang-mutton-with-rice.jpg'
    },
    {
      id: 'R209',
      code: 'R209',
      category: 'food',
      section: 'Ala Carte',
      name: 'Vegan Fish with Tomato Sauce 鲜茄杂豆素鱼片',
      price: 14.9,
      image: 'assets/images/vegan-fish-with-tomato-sauce.jpg'
    },
    {
      id: 'R210',
      code: 'R210',
      category: 'food',
      section: 'Ala Carte',
      name: 'Asam Laksa Soyfish Rice (Vegan) 亚三叻沙素鱼饭',
      price: 14.9,
      image: 'assets/images/asam-laksa-soyfish-rice-vegan.jpg'
    },
    {
      id: 'R212',
      code: 'R212',
      category: 'food',
      section: 'Ala Carte',
      name: 'Vegan Hakka Stewed Lean Meat 家木耳素瘦肉饭',
      price: 15.9,
      image: 'assets/images/vegan-hakka-stewed-lean-meat.jpg'
    },
    {
      id: 'R213',
      code: 'R213',
      category: 'food',
      section: 'Ala Carte',
      name: 'Three Taste Soyfish Rice (Vegan) 胃怪味素鱼',
      price: 17.9,
      image: 'assets/images/three-taste-soyfish-rice-vegan.jpg'
    },
    {
      id: 'R214',
      code: 'R214',
      category: 'food',
      section: 'Ala Carte',
      name: 'Black Pepper Mushroom Rice (Vegan) 黑胡椒菇团饭',
      price: 18.9,
      image: 'assets/images/black-pepper-mushroom-rice-vegan.jpg'
    },

    // =======================================================
    // DAILY SPECIAL
    // =======================================================
    {
      id: 'DSP01',
      category: 'food',
      section: 'Daily Special Package',
      name: 'Sarawak Curry Kolo Mee',
      price: 16.9,
      image: 'assets/images/sarawak-curry-kolo-mee.jpg'
    },

    // =======================================================
    // COFFEE - X BREW
    // =======================================================
    {
      id: '501',
      code: '501',
      category: 'coffee',
      section: 'X Brew',
      name: 'Paloh Liberica X Brew (Honey Process) 巴罗赖比瑞卡手冲(蜜处理)',
      price: 24,
      image: 'assets/images/paloh-liberica-x-brew-honey-process.jpg'
    },
    {
      id: '502',
      code: '502',
      category: 'coffee',
      section: 'X Brew',
      name: 'Paloh Liberica X Brew (Natural Process) 巴罗赖比瑞卡手冲(日晒处理)',
      price: 26,
      image: 'assets/images/paloh-liberica-x-brew-natural-process.jpg'
    },

    // =======================================================
    // HAND BREW
    // =======================================================
    {
      id: '521',
      code: '521',
      category: 'coffee',
      section: 'Hand Brew / Pour Over',
      name: 'Paloh Liberica Hand Brew (Honey Process) 巴罗赖比瑞卡手冲(蜜处理)',
      price: 38,
      image: 'assets/images/paloh-liberica-hand-brew-honey-process.jpg'
    },
    {
      id: '522',
      code: '522',
      category: 'coffee',
      section: 'Hand Brew / Pour Over',
      name: 'Paloh Liberica Hand Brew (Natural Process) 巴罗赖比瑞卡手冲(日晒处理)',
      price: 43,
      image: 'assets/images/paloh-liberica-hand-brew-natural-process.jpg'
    },
    {
      id: '523',
      category: 'coffee',
      section: 'Hand Brew / Pour Over',
      name: 'House Of Kendal Pour Over Specialty Liberica (Natural Process)',
      price: 39,
      image: 'assets/images/house-of-kendal-pour-over-specialty-liberica-natural-process.jpg'
    },
    {
      id: '524',
      category: 'coffee',
      section: 'Hand Brew / Pour Over',
      name: 'House Of Kendal Pour Over Specialty Liberica (Honey Process)',
      price: 35,
      image: 'assets/images/house-of-kendal-pour-over-specialty-liberica-honey-process.jpg'
    },
    {
      id: '525',
      category: 'coffee',
      section: 'Hand Brew / Pour Over',
      name: 'House Of Kendal Pour Over Specialty Liberica (Nitrogen Maceration)',
      price: 45,
      image: 'assets/images/house-of-kendal-pour-over-specialty-liberica-nitrogen-maceration.jpg'
    },

    // =======================================================
    // HOUSE OF KENDAL
    // =======================================================
    {
      id: 'H01',
      category: 'coffee',
      section: 'House Of Kendal',
      name: 'House Of Kendal Single Origin Ice White',
      price: 14,
      image: 'assets/images/house-of-kendal-single-origin-ice-white.jpg'
    },
    {
      id: 'H02',
      category: 'coffee',
      section: 'House Of Kendal',
      name: 'House Of Kendal Single Origin Hot White',
      price: 13,
      image: 'assets/images/house-of-kendal-single-origin-hot-white.jpg'
    },
    {
      id: 'H03',
      category: 'coffee',
      section: 'House Of Kendal',
      name: 'House Of Kendal Single Origin Piccolo',
      price: 16,
      image: 'assets/images/house-of-kendal-single-origin-piccolo.jpg'
    },
    {
      id: 'H04',
      category: 'coffee',
      section: 'House Of Kendal',
      name: 'House Of Kendal Single Origin Ice Black',
      price: 12,
      image: 'assets/images/house-of-kendal-single-origin-ice-black.jpg'
    },
    {
      id: 'H05',
      category: 'coffee',
      section: 'House Of Kendal',
      name: 'House Of Kendal Single Origin Hot Black',
      price: 11,
      image: 'assets/images/house-of-kendal-single-origin-hot-black.jpg'
    },
    {
      id: 'H06',
      category: 'coffee',
      section: 'House Of Kendal',
      name: 'House Of Kendal Single Origin Espresso',
      price: 11,
      image: 'assets/images/house-of-kendal-single-origin-espresso.jpg'
    },

    // =======================================================
    // MATCHA
    // =======================================================
    {
      id: 'MAT01',
      category: 'coffee',
      section: 'Matcha',
      name: 'Ice Matcha Latte',
      price: 16,
      image: 'assets/images/ice-matcha-latte.jpg'
    },
    {
      id: 'MAT02',
      category: 'coffee',
      section: 'Matcha',
      name: 'Hot Matcha Latte',
      price: 15,
      image: 'assets/images/hot-matcha-latte.jpg'
    },

    // =======================================================
    // CHOCOLATE
    // =======================================================

    {
      id: 'CHO01',
      category: 'coffee',
      section: 'Chocolate',
      name: 'Malaysian Ice Chocolate',
      price: 16,
      image: 'assets/images/malaysian-ice-chocolate.jpg'
    },
    {
      id: 'CHO02',
      category: 'coffee',
      section: 'Chocolate',
      name: 'Malaysian Hot Chocolate',
      price: 15,
      image: 'assets/images/malaysian-hot-chocolate.jpg'
    },

    // =======================================================
    // MOCHA
    // =======================================================
    {
      id: 'MOC01',
      category: 'coffee',
      section: 'Mocha',
      name: 'Malaysian Ice Mocha',
      price: 16,
      image: 'assets/images/malaysian-ice-chocolate.jpg'
    },
    {
      id: 'MOC02',
      category: 'coffee',
      section: 'Mocha',
      name: 'Malaysian Hot Mocha',
      price: 15,
      image: 'assets/images/malaysian-hot-mocha.jpg'
    },

    // =======================================================
    // BEVERAGES
    // =======================================================
    {
      id: '813H',
      code: '813H',
      category: 'beverages',
      section: 'Beverages',
      name: 'Soya 豆奶',
      price: 5.9,
      image: 'assets/images/soya.jpg'
    },
    {
      id: '814H',
      code: '814H',
      category: 'beverages',
      section: 'Beverages',
      name: 'Soya Cincau 豆奶仙草',
      price: 6.9,
      image: 'assets/images/soya-cincau.jpg'
    },
    {
      id: '810C',
      code: '810C',
      category: 'beverages',
      section: 'Beverages',
      name: 'Ice Ho Kar Sai 冰虎咬狮',
      price: 6.9,
      image: 'assets/images/ice-ho-kar-sai.jpg'
    },
    {
      id: '813C',
      code: '813C',
      category: 'beverages',
      section: 'Beverages',
      name: 'Ice Soya 冰豆奶',
      price: 7.9,
      image: 'assets/images/ice-soya.jpg'
    },
    {
      id: '814C',
      code: '814C',
      category: 'beverages',
      section: 'Beverages',
      name: 'Ice Soya Cincau 冰豆奶仙草',
      price: 7.9,
      image: 'assets/images/ice-soya-cincau.jpg'
    },
    {
      id: '818H',
      code: '818H',
      category: 'beverages',
      section: 'Beverages',
      name: 'Honey Lemon 蜂蜜柠檬',
      price: 4.9,
      image: 'assets/images/honey-lemon.jpg'
    },
    {
      id: '818C',
      code: '818C',
      category: 'beverages',
      section: 'Beverages',
      name: 'Ice Honey Lemon 冰蜂蜜柠檬',
      price: 5.9,
      image: 'assets/images/ice-honey-lemon.jpg'
    },
    {
      id: '819H',
      code: '819H',
      category: 'beverages',
      section: 'Beverages',
      name: 'Water 饮用水',
      price: 1,
      image: 'assets/images/water.jpg'
    },
    {
      id: 'IW01',
      category: 'beverages',
      section: 'Beverages',
      name: 'Ice Water 冰饮用水',
      price: 1,
      image: 'assets/images/ice-water.jpg'
    },
    {
      id: 'T101',
      code: 'T101',
      category: 'beverages',
      section: 'Beverages',
      name: 'Flower Tea (Pot) 花茶(壶)',
      price: 6.9,
      description: '1–2 Pax',
      image: 'assets/images/flower-tea-pot.jpg'
    },
    {
      id: 'CAL01',
      category: 'beverages',
      section: 'Beverages',
      name: 'Calamansi Lime Drink 冰古早金桔',
      price: 7.9,
      image: 'assets/images/calamansi-lime-drink-ice.jpg'
    },
    {
      id: 'CAL02',
      category: 'beverages',
      section: 'Beverages',
      name: 'Calamansi Lime Drink 古早金桔',
      price: 6.9,
      image: 'assets/images/calamansi-lime-drink.jpg'
    },
    {
      id: 'SUM01',
      category: 'beverages',
      section: 'Beverages',
      name: 'Summer Herbal Tea 天天涼茶',
      price: 7.9,
      image: 'assets/images/summer-herbal-tea.jpg'
    },
    {
      id: 'COC01',
      category: 'beverages',
      section: 'Beverages',
      name: '100% Fresh Coconut Water 100% 純班兰椰子水',
      price: 8,
      image: 'assets/images/fresh-coconut-water.jpg'
    },
    {
      id: 'SP01',
      category: 'beverages',
      section: 'Beverages',
      name: 'Sour Plum 酸梅汤',
      price: 8.9,
      image: 'assets/images/sour-plum.jpg'
    },
    {
      id: 'SPR01',
      category: 'beverages',
      section: 'Beverages',
      name: 'Spritzer Sparkling Water',
      price: 2.9,
      description: '400ml',
      image: 'assets/images/spritzer-sparkling-water.jpg'
    },

    // =======================================================
    // MOCKTAIL
    // =======================================================
    {
      id: '605',
      code: '605',
      category: 'beverages',
      section: 'Mocktail',
      name: 'Coco Sunrise',
      price: 15.9,
      image: 'assets/images/coco-sunrise.jpg'
    },
    {
      id: '606',
      code: '606',
      category: 'beverages',
      section: 'Mocktail',
      name: 'Coco Rush',
      price: 14.9,
      image: 'assets/images/coco-rush.jpg'
    },

    // =======================================================
    // FLOWER TEA SACHET
    // =======================================================
    {
      id: 'FT01',
      category: 'beverages',
      section: 'Flower Tea Sachet',
      name: 'Organic Green Tea with Citrus & Ginkgo 有机柑橘银杏绿茶',
      price: 12.9,
      image: 'assets/images/organic-green-tea-citrus-ginkgo.jpg'
    },
    {
      id: 'FT02',
      category: 'beverages',
      section: 'Flower Tea Sachet',
      name: 'Pomegranate Oolong 石榴铁观音乌龙茶',
      price: 12.9,
      image: 'assets/images/pomegranate-oolong.jpg'
    },
    {
      id: 'FT03',
      category: 'beverages',
      section: 'Flower Tea Sachet',
      name: 'Earl Grey Supreme 伯爵至尊红茶',
      price: 12.9,
      image: 'assets/images/earl-grey-supreme.jpg'
    },

    // =======================================================
    // SNACKS
    // =======================================================
    {
      id: '119',
      code: '119',
      category: 'desserts',
      section: 'Snacks',
      name: 'Veg Fried Fu Zuok 炸腐竹',
      price: 9.9,
      description: '5 pcs',
      image: 'assets/images/veg-fried-fu-zuok.jpg'
    },

    // =======================================================
    // BREAKFAST
    // =======================================================
    {
      id: 'B101',
      code: 'B101',
      category: 'desserts',
      section: 'Breakfast',
      name: 'Half Boiled Egg (2pcs) 生熟蛋(2粒)',
      price: 3.9,
      image: 'assets/images/half-boiled-egg.jpg'
    },

    // =======================================================
    // PASTRY
    // =======================================================
    {
      id: 'P104',
      code: 'P104',
      category: 'desserts',
      section: 'Pastry',
      name: 'Kek Lapis Prune 牛油千层蛋糕',
      price: 3.90,
      image: 'assets/images/butter-kuih-lapis.jpg'
    },
    {
      id: 'P106',
      category: 'desserts',
      section: 'Pastry',
      name: 'Mini Lemon Danish',
      price: 2.9,
      image: 'assets/images/mini-lemon-danish.jpg'
    },
    {
      id: 'P107',
      category: 'desserts',
      section: 'Pastry',
      name: 'Butter Sponge Cake 奶油海绵蛋糕',
      price: 2.5,
      description: 'Per slice',
      image: 'assets/images/butter-sponge-cake.jpg'
    },
    {
      id: 'P108',
      category: 'desserts',
      section: 'Pastry',
      name: 'Pandan Gula Melaka Cake with Coconut',
      price: 9.9,
      description: 'Per slice',
      image: 'assets/images/pandan-gula-melaka-cake-with-coconut.jpg'
    },

    // =======================================================
    // EGG TART
    // =======================================================
    {
      id: 'P105',
      code: 'P105',
      category: 'desserts',
      section: 'Egg Tart',
      name: 'Portuguese Egg Tart 葡式蛋挞',
      price: 3.5,
      image: 'assets/images/portuguese-egg-tart.jpg'
    },

    // =======================================================
    // ADD ON
    // =======================================================
    {
      id: 'ADD01',
      category: 'desserts',
      section: 'Add On',
      name: 'Takeaway Container 打包盒',
      price: 0.5,
      image: 'assets/images/takeaway-container.jpg'
    },
    {
      id: 'ADD02',
      category: 'desserts',
      section: 'Add On',
      name: 'Add Fried Egg',
      price: 2,
      image: 'assets/images/add-fried-egg.jpg'
    }
  ];


  // =========================================================
  // CART
  // =========================================================

  cartItems: any[] = [];
  totalPrice: number = 0;
  isCartOpen: boolean = false;


  // =========================================================
  // REVEAL
  // =========================================================

  private revealObserver: IntersectionObserver | null = null;
  private revealRefreshTimer: any = null;


  // =========================================================
  // CONSTRUCTOR
  // =========================================================

  constructor(
    private cartService: CartService,
    private route: ActivatedRoute
  ) {}


  // =========================================================
  // INIT
  // =========================================================

  ngOnInit(): void {
    this.syncCart();

    // Subscribe to URL fragments (e.g. #foodSection or #food)
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        this.handleFragmentNavigation(fragment);
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  }


  // =========================================================
  // NAVIGATION FRAGMENT HANDLER
  // =========================================================

  private handleFragmentNavigation(fragment: string): void {
    const fragmentMap: { [key: string]: string } = {
      'coffeeSection': 'coffee',
      'foodSection': 'food',
      'beveragesSection': 'beverages',
      'snacksDessertsSection': 'desserts',
      'coffee': 'coffee',
      'food': 'food',
      'beverages': 'beverages',
      'desserts': 'desserts'
    };

    const targetCategory = fragmentMap[fragment] || fragment;
    if (targetCategory && this.categories.some(c => c.id === targetCategory)) {
      this.selectCategory(targetCategory);
    }
  }


  // =========================================================
  // HELPER METHODS FOR SUBSECTIONS & IMAGES
  // =========================================================

  getSections(category: string): string[] {
    switch (category) {
      case 'food':
        return this.foodSections;
      case 'beverages':
        return this.beverageSections;
      case 'desserts':
        return this.dessertSections;
      case 'coffee':
        return ['X Brew', 'Hand Brew / Pour Over', 'House Of Kendal', 'Matcha', 'Chocolate', 'Mocha'];
      default:
        return [];
    }
  }

  getSectionDisplayName(section: string): string {
    return section;
  }

  getSectionSubtitle(section: string): string {
    return '';
  }

  getItemImage(item: any): string {
    return item && item.image ? item.image : this.defaultImageUrl;
  }

  onImageError(event: any): void {
    event.target.src = this.defaultImageUrl;
  }


  // =========================================================
  // CATEGORY
  // =========================================================

  selectCategory(category: string): void {
    this.selectedCategory = category;
    this.searchTerm = '';

    setTimeout(() => {
      const element = document.getElementById(category);
      if (element) {
        const headerOffset = 100;
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset;

        window.scrollTo({
          top: elementPosition - headerOffset,
          behavior: 'smooth'
        });
      }
    }, 100);

    this.refreshRevealAnimations();
  }


  // =========================================================
  // SHOW CATEGORY
  // =========================================================

  showCategory(category: string): boolean {
    if (this.searchTerm && this.searchTerm.trim()) {
      return this.filteredMenu.some(
        item => item.category === category
      );
    }

    return this.selectedCategory === category;
  }


  // =========================================================
  // FILTERED MENU
  // =========================================================

  get filteredMenu(): any[] {
    if (!this.searchTerm || !this.searchTerm.trim()) {
      return this.menuItems;
    }

    const term = this.searchTerm
      .toLowerCase()
      .trim();

    return this.menuItems.filter(item => {
      const name = String(item.name || '').toLowerCase();
      const code = String(item.code || '').toLowerCase();
      const section = String(item.section || '').toLowerCase();

      return (
        name.includes(term) ||
        code.includes(term) ||
        section.includes(term)
      );
    });
  }


  // =========================================================
  // GET ITEMS
  // =========================================================

  getItems(section: string): any[] {
    return this.filteredMenu.filter(
      item => item.section === section
    );
  }


  // =========================================================
  // SHOW SUBSECTION
  // =========================================================

  showSubsection(
    category: string,
    section: string
  ): boolean {
    const items = this.getItems(section);

    if (items.length === 0) {
      return false;
    }

    if (this.searchTerm && this.searchTerm.trim()) {
      return true;
    }

    return this.selectedCategory === category;
  }


  // =========================================================
  // SEARCH
  // =========================================================

  onSearchChange(): void {
    this.refreshRevealAnimations();
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.refreshRevealAnimations();
  }


  // =========================================================
  // CART - ADD
  // =========================================================

  increaseQty(item: any): void {
    if (!item) {
      return;
    }

    this.cartService.addToCart({
      name: item.name,
      price: Number(item.price),
      quantity: item.description || ''
    });

    this.syncCart();
  }


  // =========================================================
  // CART - REMOVE
  // =========================================================

  decreaseQty(item: any): void {
    if (!item) {
      return;
    }

    this.cartService.decreaseQty({
      name: item.name,
      quantity: item.description || ''
    });

    this.syncCart();
  }


  // =========================================================
  // GET QUANTITY
  // =========================================================

  getQty(item: any): number {
    if (!item) {
      return 0;
    }

    const cartItem = this.cartItems.find(
      cart =>
        cart.name === item.name &&
        cart.quantity === (item.description || '')
    );

    return cartItem ? Number(cartItem.qty) : 0;
  }


  // =========================================================
  // SYNC CART
  // =========================================================

  private syncCart(): void {
    this.cartItems = this.cartService.getCart() || [];
    this.totalPrice = this.cartItems.reduce(
      (sum, item) =>
        sum + (Number(item.price || 0) * Number(item.qty || 0)),
      0
    );
  }


  // =========================================================
  // CART TOTAL QUANTITY
  // =========================================================

  getTotalQuantity(): number {
    return this.cartItems.reduce(
      (total, item) => total + Number(item.qty || 0),
      0
    );
  }


  // =========================================================
  // CART TOGGLE
  // =========================================================

  toggleCart(): void {
    this.isCartOpen = !this.isCartOpen;
  }


  // =========================================================
  // CART ITEM +
  // =========================================================

  increaseCartItem(item: any): void {
    if (!item) {
      return;
    }

    this.cartService.addToCart({
      name: item.name,
      price: Number(item.price),
      quantity: item.quantity || ''
    });

    this.syncCart();
  }


  // =========================================================
  // CART ITEM -
  // =========================================================

  decreaseCartItem(item: any): void {
    if (!item) {
      return;
    }

    this.cartService.decreaseQty({
      name: item.name,
      quantity: item.quantity || ''
    });

    this.syncCart();
  }


  // =========================================================
  // WHATSAPP
  // =========================================================

  sendCartToWhatsApp(): void {
    const phoneNumber = '60105956650';

    if (this.cartItems.length === 0) {
      alert('Your cart is empty!');
      return;
    }

    let message = '🛒 *LIBERICA MY HUB ORDER*%0A%0A';
    let total = 0;

    this.cartItems.forEach(item => {
      const itemTotal = Number(item.price || 0) * Number(item.qty || 0);

      message += `• ${item.name}%0A`;

      if (item.quantity) {
        message += `  ${item.quantity} × ${item.qty} = RM ${itemTotal.toFixed(2)}%0A%0A`;
      } else {
        message += `  ${item.qty} × RM ${Number(item.price).toFixed(2)} = RM ${itemTotal.toFixed(2)}%0A%0A`;
      }

      total += itemTotal;
    });

    message += `💰 *TOTAL: RM ${total.toFixed(2)}*%0A%0A`;
    message += 'Please confirm my order. Thank you! ☕';

    window.open(
      `https://wa.me/${phoneNumber}?text=${message}`,
      '_blank'
    );
  }


  // =========================================================
  // PDF BILL
  // =========================================================

  downloadPDF(): void {
    if (this.cartItems.length === 0) {
      alert('Your cart is empty!');
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text('Liberica MY HUB Order', 15, 20);
    doc.setFontSize(10);

    let y = 35;
    let total = 0;

    this.cartItems.forEach(item => {
      const itemTotal = Number(item.price || 0) * Number(item.qty || 0);
      const line = `${item.name} - ${item.quantity || ''} x ${item.qty} = RM ${itemTotal.toFixed(2)}`;

      if (y > 270) {
        doc.addPage();
        y = 20;
      }

      doc.text(line, 15, y);
      y += 10;
      total += itemTotal;
    });

    if (y > 270) {
      doc.addPage();
      y = 20;
    }

    doc.setFontSize(14);
    doc.text(`Total: RM ${total.toFixed(2)}`, 15, y + 10);
    doc.save('Liberica-MY-HUB-Order.pdf');
  }


  // =========================================================
  // SCROLL TOP
  // =========================================================

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }


  // =========================================================
  // REVEAL ANIMATIONS
  // =========================================================

  ngAfterViewInit(): void {
    this.refreshRevealAnimations();
  }

  private refreshRevealAnimations(): void {
    if (this.revealRefreshTimer) {
      clearTimeout(this.revealRefreshTimer);
    }

    this.revealRefreshTimer = setTimeout(() => {
      this.revealRefreshTimer = null;
      this.initRevealAnimations();
    }, 0);
  }

  private initRevealAnimations(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const elements = document.querySelectorAll(
      '.menu-page .reveal, ' +
      '.menu-page .reveal-up, ' +
      '.menu-page .reveal-fade, ' +
      '.menu-page .reveal-float, ' +
      '.menu-page .reveal-tracking'
    );

    if (!('IntersectionObserver' in window)) {
      elements.forEach((element: Element) => {
        element.classList.add('active');
      });
      return;
    }

    if (!this.revealObserver) {
      this.revealObserver = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              return;
            }

            const element = entry.target;
            element.classList.add('active');

            if (this.revealObserver) {
              this.revealObserver.unobserve(element);
            }
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -60px 0px'
        }
      );
    }

    elements.forEach((element: Element) => {
      if (element.classList.contains('active')) {
        return;
      }

      if (this.revealObserver) {
        this.revealObserver.observe(element);
      }
    });
  }

  // =========================================================
  // DESTROY
  // =========================================================

  ngOnDestroy(): void {
    if (this.revealObserver) {
      this.revealObserver.disconnect();
      this.revealObserver = null;
    }

    if (this.revealRefreshTimer) {
      clearTimeout(this.revealRefreshTimer);
      this.revealRefreshTimer = null;
    }
  }

}